import type { FC } from 'react';
import React from 'react';
import { graphql, useFragment } from 'react-relay';
import ExternalResourceIcon from 'topics/src/common/ui/external-resource-fallback-icon';
import { NewTabTooltipContainer } from 'topics/src/common/ui/new-tab-tooltip-container';
import { GroupBoxLink } from '@atlassian/help-center-common-component/group-box';
import { isExternalResource, urlRefsAndTarget } from '@atlassian/help-center-common-util/is-external-resource';
import { getUpdatedDisplayLink } from '@atlassian/help-center-common-util/url';
import type { Props } from './types';

const HelpObjectRequestForm: FC<Props> = (props) => {
    const data = useFragment<Props['helpObject']>(
        graphql`
            fragment helpObjectRequestForm_HelpObjectStoreRequestForm on HelpObjectStoreRequestForm {
                title
                description
                icon {
                    iconUrl
                }
                displayLink
                entityKey
            }
        `,
        props.helpObject
    );
    const { title, description, entityKey } = data;
    if (title?.length && typeof data.displayLink === 'string' && data.displayLink) {
        const isAnExternalResource = isExternalResource(entityKey as string);
        const linkProps = urlRefsAndTarget({
            isAnExternalResource,
            displayLink: getUpdatedDisplayLink(data.displayLink),
        });
        return (
            <NewTabTooltipContainer shouldOpenInANewTab={isAnExternalResource}>
                <GroupBoxLink
                    {...linkProps}
                    icon={
                        isAnExternalResource ? (
                            <ExternalResourceIcon
                                iconUrl={getUpdatedDisplayLink(data.displayLink)}
                                resourceType="REQUEST_FORM"
                                size="large"
                            />
                        ) : (
                            (data.icon?.iconUrl as string)
                        )
                    }
                    heading={title}
                    description={description}
                    actionSubjectId="helpObject"
                ></GroupBoxLink>
            </NewTabTooltipContainer>
        );
    }
    return null;
};

export default HelpObjectRequestForm;
